import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BasicTemplate from './templates/BasicTemplate/BasicTemplate';
import CategoryTemplate from './templates/CategoryTemplate/CategoryTemplate';
import ClickableImageTemplate from './templates/ClickableImageTemplate/ClickableImageTemplate';
import MediaQueryListener from '../../helpers/MediaQueryListener';


const templateMap = {
  basic: BasicTemplate,
  category: CategoryTemplate,
  clickableImage: ClickableImageTemplate,
};

class PageHero extends Component {
  constructor(props) {
    super(props);

    this.state = { responsiveImage: props.image };
    this.TemplateComponent = templateMap[props.template];
    this.setImage = this.setImage.bind(this);
    this.mq = new MediaQueryListener(() => this.setImage());
  }

  setImage() {
    const { image, imageMobile } = this.props;
    const responsiveImage = this.mq.atMinWidth('tablet') ? image : imageMobile;

    this.setState({ responsiveImage });
  }

  render() {
    const {
      title,
      linkTo,
      subtitle,
      buttonText,
      external,
      coBranding,
      imageAltText,
    } = this.props;
    const { responsiveImage } = this.state;

    return (
      <this.TemplateComponent
        title={title}
        linkTo={linkTo}
        subtitle={subtitle}
        image={responsiveImage}
        buttonText={buttonText}
        external={external}
        coBranding={coBranding}
        imageAltText={imageAltText}
      />
    );
  }
}

PageHero.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  imageMobile: PropTypes.string.isRequired,
  template: PropTypes.PropTypes.string.isRequired,
  external: PropTypes.bool,
  coBranding: PropTypes.shape({
    tagline: PropTypes.string,
    imageUrl: PropTypes.string,
    isEnabled: PropTypes.bool,
  }),
  imageAltText: PropTypes.string,
};

PageHero.defaultProps = {
  external: false,
  coBranding: PropTypes.shape({
    tagline: '',
    imageUrl: '',
    isEnabled: false,
  }),
  imageAltText: '',
};

export default PageHero;
